import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useControlStore } from '@editorStores'

/**
 * Blocks the scene while `blocked` is true. Backed by a guid-keyed group in the control store (à la
 * `useCameraEvent`), so independent callers can request a block at the same time — the scene stays
 * blocked while any of them is true, and each registration is cleared on unblock/unmount.
 */
const useBlockScene = (blocked: boolean) => {
  const isSceneBlocked = useControlStore(state => state.isSceneBlocked)
  const addSceneBlockGroup = useControlStore(state => state.addSceneBlockGroup)
  const removeSceneBlockGroup = useControlStore(state => state.removeSceneBlockGroup)

  useLayoutEffect(() => {
    if (!blocked) return

    const guid = v4()
    addSceneBlockGroup(guid)

    return () => removeSceneBlockGroup(guid)
  }, [blocked, addSceneBlockGroup, removeSceneBlockGroup])

  return isSceneBlocked
}

export default useBlockScene
